import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-heading">Phoenix Negoce</h3>
            <p className="footer-description">
              Votre partenaire de confiance pour le textile, la maroquinerie et les pellets de bois de qualité premium.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Navigation</h4>
            <ul className="footer-links">
              <li><a href="/">Accueil</a></li>
              <li><a href="/catalogue">Catalogue</a></li>
              <li><a href="/services">Nos Services</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <span>phoenixnegoce@gmail.com</span>
              </li>
              <li>
                <Phone size={18} />
                <span>07 86 06 44 62</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Phoenix Negoce. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;